// extracted by mini-css-extract-plugin
module.exports = {"SettingsContent":"billing_SettingsContent__1SuE5","BillingModule":"billing_BillingModule__36CAD","spinner":"billing_spinner__VhDtx"};